import GoogleChart from "../../../../../components/googleChart/googleChart";
import {connect} from "react-redux";
import {actionCreators} from "../redux/sagas/totalVisitsSagas";

export default connect(
  state => ({
    chartName: "attendance_total_visits_chart",
    width: "1350px",
    height: state.totalVisitsReducer.selectedFilters.table_view ? 300 : 400,
    isTableView: state.totalVisitsReducer.selectedFilters.table_view,
    rows: state.totalVisitsReducer.chartData.data_table.rows,
    columns: state.totalVisitsReducer.chartData.data_table.cols,
    listeners: state.totalVisitsReducer.chartData.listeners,
    options: state.totalVisitsReducer.chartData.options,
    enableEventListeners: true,
    showCurrency: false
  }),
  {
    switchView: data => actionCreators.updateTableView(data)
  }
)(GoogleChart);
